import { useState } from "react";
import { faqs } from "@/mocks/community";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-background-50">
      <div className="mx-auto max-w-4xl px-4 md:px-6 py-12 md:py-16 w-full">
        <div className="text-center">
          <p className="inline-flex items-center gap-2 text-xs font-semibold tracking-wider text-accent-600 uppercase justify-center">
            <span className="w-6 h-px bg-accent-500" aria-hidden="true"></span> 帮助问答
            <span className="w-6 h-px bg-accent-500" aria-hidden="true"></span>
          </p>
          <h2 className="mt-2 text-2xl md:text-3xl font-black text-foreground-950">新瓜友高频提问</h2>
          <p className="mt-2 text-sm text-foreground-600">这些问题的答案大多能帮你快速上手，其他疑问可以随时在板块里提问。</p>
        </div>

        <div className="mt-9 space-y-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={`rounded-2xl border overflow-hidden transition-colors ${
                  open ? "border-primary-200 bg-background-100/70" : "border-background-200 bg-background-100/40"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={open}
                >
                  <span className="text-sm md:text-base font-bold text-foreground-900 flex items-center gap-3">
                    <span className="w-7 h-7 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center text-xs font-black shrink-0">
                      Q
                    </span>
                    {f.q}
                  </span>
                  <span
                    className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center transition-transform ${
                      open ? "rotate-180 bg-primary-500 text-background-50" : "bg-background-50 text-foreground-500"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg" aria-hidden="true"></i>
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-[52px] text-sm text-foreground-700 leading-relaxed">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}